<div [ngSwitch]='pano.CategoryMenuType'>
  <allviews-menu [pano]="pano" [tour]="tour" *ngSwitchCase="'All Views'" (toggleOpen)="toggleOpen.emit($event)"
                 (viewSelect)="viewSelect.emit($event)"></allviews-menu>
  <basic-menu [pano]="pano" [tour]="tour" [view]="view" *ngSwitchCase="'Default'" [isControlsMenuOpen]="isOpen" (toggleOpen)="toggleOpen.emit($event)"
              (viewSelect)="viewSelect.emit($event)" (checkValidCombo)="showValidCombo($event)"></basic-menu>
  <thumbnail-menu [view]="view" *ngSwitchCase="'Thumbnail'"></thumbnail-menu>
</div>